import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import { WhatsAppQuickSendsList } from "../../../../../../WhatsAppQuickSends"

export default function WhatsAppIntegrationQuickSendsPage() {
	const context = useOutletContext<{
		integrationId: number
		appId: number
	}>()

	return (
		<>
			<Helmet>
				<title>Quick Sends | WA</title>
			</Helmet>
			<WhatsAppQuickSendsList integrationId={context.integrationId} />
		</>
	)
}
